import axios from 'axios'
import { PageDataResponse ,PageResponse ,DataArrayResponse} from '../models/PageResponse'
import { ProjectMode}  from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class ProjectModeService
{
    protected headers = {}
 protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
    }
    
    async getAll(page: number,limit: number,key:string){
        let options = {
                headers: this.headers,
                params: {
                    page: page,
                    limit: limit,
                    key: key
                }
            }
        
        const { data }  = await axios.get<PageDataResponse<ProjectMode>>(`${apiUrl}/v1/projectmodes/call`, options )
        
        return data;
    }

    async search(key:string){
        let options = {
            headers:this.headers,
            params: {
                key: encodeURI(key)
            }
        }
        const { data }   = await axios.get<DataArrayResponse<ProjectMode>>(`${apiUrl}/v1/projectmodes/search`,options )
        return data;
    }

    async create(projectMode: ProjectMode){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/projectmodes/call`,JSON.stringify(projectMode),options )
        return data;
    }

    async update(projectMode: ProjectMode){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/projectmodes/call`,JSON.stringify(projectMode),options )
        return data;
    }

    async updateStatus(projectMode: ProjectMode){
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/projectmodes/status`,JSON.stringify(projectMode),options )
        return data;
    }
}